<script>
	import { createEventDispatcher } from "svelte";

	export let style = false;
	export let disabled = false;

	const dispatcher = createEventDispatcher();

	const deleteItem = () => {
		dispatcher("delete");
	};

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button class={className} {style} title="Delete" on:click|preventDefault={deleteItem} {disabled} type="submit">
	<i class="fa fa-trash"></i>
</button>

<style>
	button {
		color: var(--color-body);
		background-color: transparent;
		border: none;
		padding: 0;
		font-size: 18px;
		cursor: pointer;
	}
</style>
